import {fetchNextApiCall, api} from 'app/services/api';
import {catchDataError, parseLinkHeader} from 'app/helpers/apiHelpers';
import {marketplaceFilters} from 'app/components/stream/streamFilter.const';
import {updateHistory} from 'app/actions/historyActions';
import {updateHttpErrorSubroute} from 'app/components/error/ErrorHandlerActions';

const createStreamQuery = (categories, filters) => {
  const filterOption = filters.find(filter => filter.param === categories);
  if (filterOption) {
    return filterOption.slug.join(',');
  } else {
    return filters.map(filter => filter.slug.map(slug => slug).join(',')).join(',');
  }
};

const getDistrictMarketplace = (districtSlug, categories) => {
  let filter = createStreamQuery(categories, marketplaceFilters);
  return api.get(`/marketplace?district=${districtSlug}&category=${filter}`);
};

//DISTRICT_MARKETPLACE_PAGE
function updateMarketplace(data) {
  return {
    type: 'DISTRICT_MARKETPLACE_UPDATE',
    data,
  };
}

function errorMarketplace(data) {
  return {
    type: 'DISTRICT_MARKETPLACE_ERROR',
    data,
  };
}

function fetchingMarketplace() {
  return {
    type: 'DISTRICT_MARKETPLACE_FETCHING',
  };
}

function overwriteMarketplace(data) {
  return {
    type: 'DISTRICT_MARKETPLACE_OVERWRITE',
    data,
  };
}

function fetchDistrictMarketplace(slug, categories, reloading, dispatchRedux) {
  return function (dispatch, state) {
    if (!reloading && state.items.length) {
      return;
    }

    const {isFetching, nextUrl} = state;
    if (isFetching || nextUrl === null) {
      return;
    }
    const fetchFunc = nextUrl ? fetchNextApiCall(nextUrl) : getDistrictMarketplace(slug, categories);
    dispatch(fetchingMarketplace());
    return fetchFunc
      .then(response => {
        const meta = parseLinkHeader(response.headers.link);
        const nextUrl = meta.next ? meta.next : null;
        dispatch(updateMarketplace({items: response.data, nextUrl, categories}));
      })
      .catch(error => {
        const errorData = catchDataError(error);
        nextUrl ? dispatch(errorMarketplace(errorData)) : dispatchRedux(updateHttpErrorSubroute(errorData));
      });
  };
}

function fetchDistrictMarketplaceSSR(slug, categories) {
  return function (dispatch) {
    dispatch(fetchingMarketplace());
    return getDistrictMarketplace(slug, categories)
      .then(response => {
        const meta = parseLinkHeader(response.headers.link);
        const nextUrl = meta.next ? meta.next : null;
        dispatch(
          updateHistory('undefined', {
            store: 'DistrictMarketplacePage',
            data: {items: response.data, nextUrl, categoryFilter: categories, error: null, isFetching: false},
          })
        );
      })
      .catch(error => {
        const errorData = catchDataError(error);
        dispatch(updateHttpErrorSubroute(errorData));
      });
  };
}

export {fetchDistrictMarketplaceSSR, fetchDistrictMarketplace, overwriteMarketplace};
